import { gql } from '@apollo/client';
import { CommentFragment } from './fragments/Comment';

export const QueryLoadComments = gql`
  query LoadComments($entityId: Int!, $offset: Int!) {
    loadMoreComments(entityId: $entityId, offset: $offset) {
      ...Comment
    }
  }

  ${CommentFragment}
`;
